import React from 'react';
import {connect} from "react-redux";
import FeatureName from "../../../visComponents/featureName";
import PropTypes from "prop-types";
import {featureInterface} from "../../../../interfaces/featureInterface";
import {MANUAL_CALCULATION_MEASURE, MANUAL_CALCULATION_ROW_TYPES} from "../../constants";
import {updateManualCalculateRow} from "../../../../actions/sqftManualCalculationFunctions";

const SqftEdgeRowDropdown = (props) => {
  const {edgeFeature, handleToggleShowTypeClick, updateRowSelectedFeatureAfterIndex, row, updateManualCalculateRow} = props;

  const handleUpdateClick = (event, edgeFeature) => {
    event.preventDefault();

    updateManualCalculateRow(
      MANUAL_CALCULATION_ROW_TYPES.edgeRows,
      row,
      {[MANUAL_CALCULATION_MEASURE.selectedFeature]: edgeFeature}
    );

    updateRowSelectedFeatureAfterIndex(row.id, edgeFeature);
    handleToggleShowTypeClick();
  };

  const activeClass = row.selectedFeature && row.selectedFeature.dbFeature.id === edgeFeature.dbFeature.id ? "active" : "";

  return (
    <li className={"drop-down-list-item " + activeClass}
        onClick={(e) => {handleUpdateClick(e, edgeFeature)}}
    >
       <FeatureName feature={edgeFeature}/>
    </li>
  )
};

SqftEdgeRowDropdown.propTypes = {
  edgeFeature: PropTypes.shape(featureInterface),
};


const mapStateToProps = () => ({
});

const mapDispatchToProps = {
  updateManualCalculateRow
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftEdgeRowDropdown);
